import { useEffect, useState } from 'react';

import Sidebar from '../components/Sidebar';

import { supabase } from '../supabase/config';

import './Content.css';

const Content = () => {

    const [content, setContent] = useState([]);


    const getContent = async () => {

        const { data, error } = await supabase
        .from('content')
        .select('*');

        if(data){
            setContent(data);
        }

        if(error){
            console.log(error);
        }
    }


    useEffect(() => {

        getContent();

    }, []);


    return (

        <div className="content-page">

            <Sidebar />

            <div className="content-main">

                <h1>Website Content</h1>

                <p className="content-text">
                    Control and manage website sections dynamically.
                </p>


                <div className="content-container">

                    {content.map((item) => (

                        <div
                            className="content-card"
                            key={item.id}
                        >

                            <span>{item.section}</span>

                            <h2>{item.title}</h2>

                            <p>{item.decription}</p>

                        </div>

                    ))}

                </div>

            </div>

        </div>

    );
}

export default Content;